import EventEmitter from "events";

export default class EventBus {
    static session: EventEmitter = new EventEmitter();
    static error: EventEmitter = new EventEmitter();
    static visibility: EventEmitter = new EventEmitter();
    static components: EventEmitter = new EventEmitter();
}